import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import Input from '@material-ui/core/Input';
// import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
// import InputAdornment from '@material-ui/core/InputAdornment';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import SuccessPopUp from '../../loaderpopup/success';
import ErrorPopUp from '../../loaderpopup/error';
import { MenuItem } from '@material-ui/core';
// import ButtonComp from '../../button';
import './styles.css';
import moment from 'moment';
import axios from 'axios';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useRef } from 'react';
import { CommonConfig } from '../../../config/common-config';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     display: 'flex',
    //     flexWrap: 'wrap',
    // },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function NameReservation(props) {
    const classes = useStyles();
    const [selectedValue, setSelectedValue] = React.useState('a');
    const [successpop, setSuccessPop] = React.useState(false);
    const [errorpop, setErrorPop] = React.useState(false);
    const [selectedFileData, setSelectedFileData] = React.useState(null);
    const [title, setTitle] = React.useState('');
    const [isDisable, setIsDisable] = React.useState(true);
    const fileInputRejectionRef = useRef(null);
    const fileInputRegisteredRef = useRef(null);
    const [filenameRejection, setFilenameRejection] = React.useState('');
    const [filenameRegistered, setFilenameRegistered] = React.useState('');
    const [IsUploading, setIsUploading] = React.useState(0);
    const [rejected, IsRejected] = React.useState(0);
    const [accepted, IsAccepted] = React.useState(0);
    const [error, setError] = React.useState(0);
    const [namesRejected, setNamesRejected] = React.useState(0);
    const [values, setValues] = React.useState({
        company_type: '',
        is_subsidiary: '',
        company_overview: '',
        company_name_one: '',
        activity_name_one: '',
        company_name_two: '',
        activity_name_two: '',
        activity_name_three: '',
        company_name_three: '',
        activity_name_four: '',
        company_name_four: '',
        status: '',
        name_rejection_file: '',
        name_registered_file: '',
        name_reservations: [],
    });

    let year;
    let month;
    let day;
    if (values.name_reservations?.[0]?.reserved_on != null) {
        const originalDate = values.name_reservations?.[0]?.reserved_on;
        const dateObject = new Date(originalDate);
        year = dateObject.getFullYear();
        month = String(dateObject.getMonth() + 1).padStart(2, '0');
        day = String(dateObject.getDate()).padStart(2, '0');
    } else {
        year = '';
        month = '';
        day = '';
    }

    let currentDate = new Date();

    // Get the current day, month, and year
    let dayCurrent = currentDate.getDate().toString().padStart(2, '0'); // Returns the day of the month (1-31)
    let monthCUrrent = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Returns the month (0-11, so add 1 to get 1-12)
    let yearCurrent = currentDate.getFullYear(); // Returns the year (four digits)

    React.useEffect(() => {
        setValues(props.NameReservationData);
    }, [props.NameReservationData]);

    const fileUpload = (e, fieldName) => {
        e.preventDefault();

        let url;
        if (values?.name_reservations?.length == 0) {
            setTitle('There is no name reservation created for this service');
            setErrorPop('File upload failed');
        } else {
            if (fieldName == 'name_rejection_file') {
                setFilenameRejection(e.target.files[0].name);
                url = `${CommonConfig.dev.appUrl}/api/admin/name_reservations/${values.name_reservations?.[0]?.id}/upload_document/attempt_two_document`;
            } else {
                setFilenameRegistered(e.target.files[0].name);
                url = `${CommonConfig.dev.appUrl}/api/admin/name_reservations/${values.name_reservations?.[0]?.id}/upload_document/name_reservation_letter`;
            }
            const data = new FormData();
            data.append('file', e.target.files[0]);
            setIsUploading(1);

            axios
                .post(url, data, {
                    // headers: {
                    //     Authorization:
                    //         'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjo0OSwiZW1haWwiOiJhcnVuQG1pbmRzdGFjay5pbiIsImZpcnN0X25hbWUiOiJzaGF6YWQiLCJsYXN0X25hbWUiOiJtYXZlZCJ9LCJpYXQiOjE2ODU3Njg2MTAsImV4cCI6MTY4NTg1NTAxMH0.521N_--SoyNeVTlL082PR8OD_ThVs0zwWzMvkwQTmmI',
                    // },
                })
                .then((response) => {
                    setTitle('File uploaded successfuly');
                    setSuccessPop(true);
                    console.log(e);
                    setIsUploading(0);
                    if (response.data) {
                        if (fieldName == 'name_rejection_file') {
                            console.log(response.data);
                            setValues({ ...values, name_rejection_file: response.data.data.path });
                        } else {
                            setValues({ ...values, name_registered_file: response.data.data.path });
                        }

                        console.log(response.data.data.path);
                    }
                })
                .catch((error) => {
                    setIsUploading(0);
                    if (error && error.response && error.response.data) {
                        setTitle('File upload failed. Please try uploading pdf file');
                        setErrorPop('File upload failed');
                    }
                });
        }
    };

    //console.log('values from child', values);
    const handleClose = () => {
        setSuccessPop(false);
    };

    const handleChange = (prop) => (event) => {
        const selectedValue = event.target.value;
        if (selectedValue == 'Name 4 Rejected') {
            IsRejected(1);
            IsAccepted(0);
        } else {
            IsRejected(0);
            IsAccepted(1);
        }

        if (prop == 'status') {
            // if (event.target.value == 'Name 3 Accepted' || event.target.value == 'Name 4 Accepted') {
            //     setError(1);
            // }
        }

        if (prop == 'reserved_on') {
            console.log(event.target.value);
            if (event.target.value == '') {
                setError(1);
            } else {
                setError(0);
            }
        }

        setValues({
            ...values,
            name_reservations: [
                {
                    ...values.name_reservations[0],
                    [prop]: selectedValue,
                },
            ],
        });
    };

    const handleSubmit = () => {
        const url = `${CommonConfig.dev.appUrl}/api/admin/name_reservations/${values.name_reservations?.[0]?.id}`;
        const data = {
            status: values.name_reservations[0].status,
            related_document_attempt_two: values.name_rejection_file,
            name_reservation_letter: values.name_registered_file,
            reserved_on: values.name_reservations?.[0]?.reserved_on || `${yearCurrent}-${monthCUrrent}-${dayCurrent}`,
        };
        // const headers = {
        //     Authorization:
        //         'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjo0OSwiZW1haWwiOiJhcnVuQG1pbmRzdGFjay5pbiIsImZpcnN0X25hbWUiOiJzaGF6YWQiLCJsYXN0X25hbWUiOiJtYXZlZCJ9LCJpYXQiOjE2ODU4NTYzNDYsImV4cCI6MTY4NTk0Mjc0Nn0.Nd7lXNAmWwkjhL2zAIhB8TV5ejCLF65U1q5EBclWTGo',
        //     'Content-Type': 'application/json',
        // };
        if (IsUploading == 1) {
            setTitle('File Upload is in Progress');
            setErrorPop(true);
        } else {
            axios
                .patch(url, data)
                .then((response) => {
                    setTitle('Data Updated Successfuly');
                    setSuccessPop(true);
                })
                .catch(() => {
                    setTitle('Data Updation failed');
                    setErrorPop(true);
                });
        }
    };

    return (
        <Grid container spacing={3} className="main-container">
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="first-name">Type of Company</InputLabel>
                    <FormControl component="fieldset">
                        <RadioGroup
                            defaultValue=""
                            // aria-label="aadhar"
                            name="customized-radios"
                            className="radio-option"
                            style={{ marginTop: '30px' }}
                        >
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel
                                        value="Public Company"
                                        control={<StyledRadio />}
                                        label="Public Company"
                                        disabled
                                        checked={values.company_type === 'Public Company' || values.company_type === 'public_company'}
                                    />
                                </li>
                                <li>
                                    <FormControlLabel
                                        value="Private Company"
                                        control={<StyledRadio />}
                                        disabled
                                        label="Private Company"
                                        className="cursor-default"
                                        checked={values.company_type === 'Private Company' || values.company_type === 'private_company'}
                                    />
                                </li>
                                <li>
                                    <FormControlLabel
                                        value="One Person Company"
                                        control={<StyledRadio />}
                                        disabled
                                        label="One Person Company"
                                        className="cursor-default"
                                        checked={
                                            values.company_type === 'One Person Company' || values.company_type === 'one_person_company'
                                        }
                                    />
                                </li>
                                <li>
                                    <FormControlLabel
                                        value="LLP"
                                        control={<StyledRadio />}
                                        disabled
                                        label="LLP"
                                        className="cursor-default"
                                        checked={values.company_type === 'LLP'}
                                    />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="first-name">Subsidiary of a company incorporated outside India?</InputLabel>
                    <FormControl component="fieldset">
                        <RadioGroup
                            defaultValue=""
                            // aria-label="aadhar"
                            name="customized-radios"
                            className="radio-option"
                            style={{ marginTop: '30px' }}
                        >
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel
                                        value="true"
                                        control={<StyledRadio />}
                                        label="Yes"
                                        disabled
                                        checked={values.is_subsidiary === true}
                                    />
                                </li>
                                <li>
                                    <FormControlLabel
                                        value="false"
                                        control={<StyledRadio />}
                                        disabled
                                        label="No"
                                        className="cursor-default"
                                        checked={values.is_subsidiary === false}
                                    />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="company_overview">Company Overview</InputLabel>
                    <Input
                        disabled
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.company_overview || ''}
                        onChange={handleChange('company_overview')}
                    />
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="pan">Name 3 (Unique Name) </InputLabel>
                    <Input
                        disabled
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.company_name_three || ''}
                        onChange={handleChange('company_name_three')}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="Address-Line-1">Name 3 (Activity Name) </InputLabel>
                    <Input
                        disabled
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.activity_name_three || ''}
                        onChange={handleChange('activity_name_three')}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="Address-Line-2">Name 4 (Unique Name) </InputLabel>
                    <Input
                        disabled
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.company_name_four || ''}
                        onChange={handleChange('company_name_four')}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="Address-Line-2">Name 4 (Activity Name) </InputLabel>
                    <Input
                        disabled
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.activity_name_four || ''}
                        onChange={handleChange('activity_name_four')}
                    />
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="status">Status</InputLabel>
                    <Select
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.name_reservations?.[0]?.status || ''}
                        onChange={handleChange('status')}
                        name="status"
                        disabled={
                            props.NameReservationData?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
                            props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Accepted' ||
                            props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Rejected'
                                ? true
                                : false
                        }
                    >
                        <MenuItem value="Name 4 Rejected">Both Names Rejected</MenuItem>

                        <MenuItem value="Name 3 Accepted">Name 3 Accepted</MenuItem>
                        <MenuItem value="Name 4 Accepted">Name 4 Accepted</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
                {props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Rejected' || rejected === 1 ? (
                    <FormControl fullWidth>
                        <InputLabel htmlFor="pin">Names Rejection Document</InputLabel>

                        <DialogActions className="paddingBtm txtCenter">
                            <Button
                                className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                onClick={(e) => {
                                    fileInputRejectionRef.current.click();
                                }}
                                variant="contained"
                                // disabled={isDisable}
                                component="label"
                                // color="default"
                                disabled={
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Accepted' ||
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Rejected'
                                        ? true
                                        : false
                                }
                            >
                                Upload
                            </Button>
                            <input
                                type="file"
                                name="name_rejection_file"
                                ref={fileInputRejectionRef}
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                    fileUpload(e, 'name_rejection_file');
                                }}
                            />
                        </DialogActions>
                    </FormControl>
                ) : null}
                {filenameRejection ? <p className="fileNameGreen">{filenameRejection}</p> : ''}
                {values.name_reservations?.[0]?.related_document_attempt_two ? (
                    <>
                        <p style={{ marginTop: 0 }}>
                            <a
                                href={values.name_reservations?.[0]?.related_document_attempt_two}
                                target="_blank"
                                style={{ textDecoration: 'none', color: '#4c4fa6' }}
                            >
                                View
                            </a>
                        </p>
                    </>
                ) : (
                    ''
                )}
                <p></p>
            </Grid>
            <Grid item xs={12} sm={6}>
                {props.NameReservationData?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
                props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Accepted' ||
                accepted === 1 ? (
                    <FormControl fullWidth>
                        <InputLabel htmlFor="dob">Name Reservation Letter</InputLabel>
                        <DialogActions className="paddingBtm txtCenter">
                            <Button
                                className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                onClick={(e) => {
                                    fileInputRegisteredRef.current.click();
                                }}
                                variant="contained"
                                // disabled={isDisable}
                                component="label"
                                // color="default"
                                disabled={
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Accepted' ||
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Rejected'
                                        ? true
                                        : false
                                }
                            >
                                Upload
                            </Button>
                            <input
                                type="file"
                                name="name_registered_file"
                                ref={fileInputRegisteredRef}
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                    // console.log(e);
                                    fileUpload(e, 'name_registered_file');
                                }}
                            />
                        </DialogActions>
                    </FormControl>
                ) : null}
                {filenameRegistered ? <p className="fileNameGreen">{filenameRegistered}</p> : ''}

                {values.name_reservations?.[0]?.name_reservation_letter ? (
                    <>
                        <p style={{ marginTop: 0 }}>
                            <a
                                href={values.name_reservations?.[0]?.name_reservation_letter}
                                target="_blank"
                                style={{ textDecoration: 'none', color: '#4c4fa6' }}
                            >
                                View
                            </a>
                        </p>
                    </>
                ) : (
                    ''
                )}
            </Grid>
            <Grid item xs={12} sm={12}>
                {props.NameReservationData?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
                props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Accepted' ||
                accepted === 1 ? (
                    <>
                        <InputLabel htmlFor="reserved_on">
                            <strong>Name reserved on</strong>
                        </InputLabel>
                        <FormControl fullWidth>
                            <Input
                                type="date"
                                required
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={`${year}-${month}-${day}`}
                                // defaultValue={
                                //     year && month && day ? `${year}-${month}-${day}` : `${yearCurrent}-${monthCUrrent}-${dayCurrent}`
                                // }
                                onChange={handleChange('reserved_on')}
                                disabled={
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Accepted' ||
                                    props.NameReservationData?.name_reservations?.[0]?.status == 'Name 4 Rejected'
                                        ? true
                                        : false
                                }
                                inputProps={{ min: `${yearCurrent}-${monthCUrrent}-${dayCurrent}` }}
                            />
                        </FormControl>{' '}
                        <p style={{ color: 'red' }}>{error == 1 ? 'Reserved On is required' : ''}</p>
                    </>
                ) : (
                    ''
                )}
            </Grid>
            {successpop ? (
                <SuccessPopUp
                    open={successpop}
                    showSuccess={successpop}
                    handleClose={handleClose}
                    title={title}
                    disableBackdropClick={false}
                />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={title} disableBackdropClick={false} />
            ) : null}
            <Button
                className="btnBluepop"
                onClick={handleSubmit}
                variant="contained"
                // disabled={isDisable}
                component="label"
                disabled={namesRejected == 1 || error == 1 ? true : false}
                // color="default"
            >
                Submit
            </Button>
        </Grid>
    );
}
